import React, { useEffect } from "react";
import PageChrome, { BLUE } from "./components/PageChrome";
import { VerticalOffers } from "./components/ConversionKit";

export default function Programas() {
  useEffect(() => { document.title = "Programas · The Debt Guy"; }, []);
  return (
    <PageChrome active="/programas" testid="programas-page">
      <section style={{ maxWidth: 1200, margin: "0 auto", padding: "80px 40px 0" }} data-testid="programas-hero">
        <div className="cg-mono cg-eyebrow">— Tres verticales · un mismo playbook</div>
        <h1 className="cg-h1" style={{ marginTop: 18, maxWidth: 940 }} data-testid="programas-hero-title">
          Elige tu camino para <span style={{ color: BLUE }}>levantar deuda.</span>
        </h1>
        <p style={{ marginTop: 22, fontSize: 19, lineHeight: 1.55, opacity: 0.78, maxWidth: 700 }}>
          Cada vertical tiene tres niveles: empieza con el <strong>ebook</strong>, sube al <strong>curso</strong> aplicado, o entra a <strong>The Debt Program</strong> donde lo hacemos juntos.
        </p>
      </section>

      <VerticalOffers testid="programas-offers" />
    </PageChrome>
  );
}
